<div *ngIf="showTestBanner" class="test-site-banner" role="status" aria-live="polite">
  {{ testBannerText }}
</div>
<app-nav></app-nav>
<main id="main-content">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>